var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("AppNavigation", {
    scopedSlots: _vm._u([
      {
        key: "list",
        fn: function() {
          return [
            _c("AppNavigationItem", {
              attrs: {
                to: { name: "TOP" },
                icon: "icon-category-dashboard",
                title: _vm.t("radio", "Top")
              }
            }),
            _vm._v(" "),
            _c("AppNavigationItem", {
              attrs: {
                to: { name: "RECENT" },
                icon: "icon-recent",
                title: _vm.t("radio", "Recent")
              }
            }),
            _vm._v(" "),
            _c("AppNavigationItem", {
              attrs: {
                to: { name: "NEW" },
                icon: "icon-category-monitoring",
                title: _vm.t("radio", "New")
              }
            }),
            _vm._v(" "),
            _c("AppNavigationItem", {
              attrs: {
                to: { name: "FAVORITES" },
                icon: "icon-favorite",
                title: _vm.t("radio", "Favorites")
              }
            }),
            _vm._v(" "),
            _c("AppNavigationItem", {
              attrs: {
                to: { name: "CATEGORIES" },
                icon: "icon-files-dark",
                title: _vm.t("radio", "Categories")
              }
            }),
            _vm._v(" "),
            _vm.isSearch
              ? _c(
                  "AppNavigationItem",
                  {
                    attrs: {
                      to: { name: "SEARCH" },
                      icon: "icon-search",
                      title: _vm.t("radio", "Search")
                    }
                  },
                  [
                    _c(
                      "AppNavigationCounter",
                      {
                        attrs: { slot: "counter", highlighted: true },
                        slot: "counter"
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(_vm.stationData.length) +
                            "\n\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [_c("Player", { attrs: { pinned: true } })]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }